import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IconWarningTriangle } from "./icons";

export const IntegrationWarningModal = ({ show, onHide, onConfirm, integrationErrors }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" size="lg">
      <Modal.Header
        closeButton
        className="px-4 border-0 integration-modal-header" 
        style={{ backgroundColor: "#C2660A" }}
      >
        <Modal.Title className="d-flex align-items-center gap-3 fw-bold" style={{ color: "#FFFFFF" }}>
          <IconWarningTriangle size={24} style={{ color: "#FFFFFF" }} />
          <span style={{ color: "#FFFFFF" }}>{t("IntegrationSyncWarning", "Integraatiopäivitys")}</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <p className="mb-4">
          {t(
            "IntegrationDataIncomplete",
            "Henkilön tiedot tallennetaan HR-järjestelmään, mutta seuraavat integraatiot eivät päivity puuttuvien tietojen vuoksi:",
          )}
        </p>

        {integrationErrors.map((integration) => (
          <div key={integration.name} className="mb-4 p-3 border rounded bg-light">
            <h5 className="text-dark border-bottom pb-2 fw-bold">{integration.name}</h5>
            <div className="row">
              {integration.missingFields.map((field) => (
                <div key={field.label} className="col-md-6 mb-2">
                  • {t(field.label, field.label)}
                </div>
              ))}
            </div>
          </div>
        ))}

        <p className="fw-bold mt-3 text-center">
          {t("DoYouWantToSaveAnyway", "Haluatko tallentaa HR-tiedot ilman integraatioiden synkronointia?")}
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0 pb-4">
        <Button className="btn-return" onClick={onHide}>
          {t("BackToForm", "Palaa muokkaamaan")}
        </Button>

        <Button variant="primary" onClick={onConfirm}>
          {t("SaveAnyway", "Tallenna silti")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
